import { AppImage } from "@/src/components/NextImage";
import { memo } from "react";
import { I18nUtil } from "@utils";
import Translations from "@translate/components/Watchlist/EmptyState";

const I18n = I18nUtil.createScoped(Translations);

const EmptyState = memo(({ isSearch }: { isSearch: boolean }) => {
  return (
    <>
      {!isSearch ? (
        <div className="flex flex-col items-center mt-[78px]">
          <AppImage
            src="/assets/images/search-watchlist.webp"
            alt="token-seek-logo"
            width={140}
            height={140}
          />
          <div className="body_l text-content_primary">
            {I18n.t("Add To Your Watchlist!")}
          </div>
          <div className="body_l text-content_quaternary">
            {I18n.t(
              "Search for tokens to track, your future self will thank you for keeping an eye on the right ones 👀",
            )}
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-2 justify-center mt-[102px]">
          <AppImage
            src="/assets/images/searchEmpty.webp"
            alt="no-result"
            width={86}
            height={86}
          />
          <span className="body_s text-content_tertiary">
            {I18n.t("No search results yet")}
          </span>
        </div>
      )}
    </>
  );
});
EmptyState.displayName = "EmptyState";

export default EmptyState;
